"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.5.3'] && _();
}
catch (e) { }
